import LinkedIn from './LinkedIn';

export default LinkedIn;
